import {ViewController} from "data/types/structure";
import {action, makeAutoObservable, observable} from "mobx";
import {inject, injectable} from "inversify";
import {ILeague} from "data/types/entities";
import {Bindings} from "data/constants/bindings";
import type {ILeaguesStore} from "data/stores/leagues/leagues.store";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {ModalType} from "data/enums";

export interface ILeagueAboutController extends ViewController {
	get isLoading(): boolean;
	get league(): ILeague | undefined;
	get leagueStarted(): boolean;

	leaveFromLeague: () => void;
	showLeaveModal: () => void;
}

@injectable()
export class LeagueAboutController implements ILeagueAboutController {
	constructor(
		@inject(Bindings.LeaguesStore) private _leagueStore: ILeaguesStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	@observable private _isLoading: boolean = false;

	get isLoading(): boolean {
		return this._leagueStore.isLoading;
	}

	get league(): ILeague | undefined {
		return this._leagueStore.selectedLeague;
	}

	get leagueStarted(): boolean {
		return this.league?.status !== "scheduled";
	}

	dispose(): void {
		return;
	}

	@action
	public leaveFromLeague = (): void => {
		if (this.league) {
			void this._leagueStore.leaveLeagueById(this.league.id).then(() => {
				window.location.href = `${process.env.PUBLIC_URL || ""}/leagues`;
			});
		}
	};

	@action
	public showLeaveModal = (): void => {
		this._modalsStore.showModal(ModalType.LEAGUELEAVE);
	};

	init(param: void): void {
		return;
	}
}
